import React from 'react';
import {
  isNonEmptyString,
  formatCurrency
} from '@uma/react-commons/dist/index';
import {
  OfferPricing,
  OfferPriceBefore,
  OfferCurrentPrice
} from '../../styles';

export type OfferPrice = {
  before?: number | string;
  current: number | string;
  currency: string | null;
};

type MountOfferPriceProps = {
  showPriceDeviceDetailsOffer: boolean;
  price: OfferPrice;
  country: string;
  language: string;
};

const mountOfferPrice = (
  props: MountOfferPriceProps
): React.JSX.Element | null => {
  if (!props) return null;
  const { showPriceDeviceDetailsOffer, price, country, language } = props;

  const isValid =
    showPriceDeviceDetailsOffer &&
    price &&
    price.current &&
    country &&
    language &&
    !isNaN(Number(price.current)) &&
    isNonEmptyString(country) &&
    isNonEmptyString(language) &&
    isNonEmptyString(price.currency);
  if (!isValid) return null;

  const locale = `${language.trim().toLowerCase()}-${country.trim().toUpperCase()}`;
  if (!locale && !isNonEmptyString(locale)) return null;

  const formattedCurrent = formatCurrency(
    price.current,
    price.currency,
    locale
  );
  if (!formattedCurrent) return null;

  const hasDiscount =
    price.before &&
    !isNaN(Number(price.before)) &&
    Number(price.before) > Number(price.current);

  if (hasDiscount) {
    const formattedBefore = formatCurrency(
      price.before,
      price.currency,
      locale
    );
    if (!formattedBefore) return null;
    return (
      <OfferPricing>
        <OfferPriceBefore
          className="caption"
          aria-label="Price before discount"
        >
          {formattedBefore}
        </OfferPriceBefore>
        <OfferCurrentPrice
          className="caption"
          aria-label="Current price"
        >
          {formattedCurrent}
        </OfferCurrentPrice>
      </OfferPricing>
    );
  }

  return (
    <OfferPricing>
      <OfferCurrentPrice
        className="caption"
        aria-label="Current price"
      >
        {formattedCurrent}
      </OfferCurrentPrice>
    </OfferPricing>
  );
};

export default mountOfferPrice;
